module.exports = __webpack_public_path__ + "static/media/elevator.33cd8ad8.JPG";